import React,{useState,useEffect} from 'react';

const Weathercard = ({tempInfo}) => {
    
    const [weatherState, setWeatherState] = useState("");
    // const [weatherTheme,setWeatherTheme]=useState("");
    const {
        temp,
        humidity,
        pressure,
        Weathermood,
        name,
        speed,
        country,
        sunset
    }=tempInfo;
     
    let sec=sunset;
    let date=new Date(sec*1000);
    let timestr=`${date.getHours()}:${date.getMinutes()}`;
    // let weatherthm =document.getElementsByClassName("weatherIcon").innerHTML;
    console.log(Weathermood);
    useEffect(() => {
        if (Weathermood) {
          switch (Weathermood) {
            case "Clouds":
              setWeatherState("wi-day-cloudy");
              // setWeatherTheme("linear-gradient(to top right, #c2c2d6, #6666cc)");
              break;
            case "Haze":
              setWeatherState("wi-fog");
              break;
            case "Clear":
              setWeatherState("wi-day-sunny");
              break;
            case "Mist":
              setWeatherState("wi-dust");
              break;
            default:
              setWeatherState("wi-day-sunny");
              break; 
          }
        }
      }, [Weathermood]);

  return (
    <>
     <article className="widget">
       <div className="weatherIcon">
        <i className={`wi ${weatherState}`}></i>
        </div> 
        <div className="weatherInfo">
            <div className="temperature">
                <span>{temp}&deg;</span>
            </div>
            <div className="description" >
                <div className="weatherCondition" >
                    {Weathermood}
                </div>
                <div className="place">
                   {name},{country}  
                </div>
            </div>
        </div>
        <div className="date">{new Date().toLocaleString()}</div>




        <div className="extra-temp">
            <div className="temp-info-minmax">
                <div className="two-sided-section">
                    <p><i className={"wi wi-sunset"}></i></p>
                    <p className="extra-info-leftside">
                        {timestr}<br>
                        </br>
                        Sunset
                    </p>
                </div>


                <div className="two-sided-section">
                    <p><i className={"wi wi-humidity"}></i></p>
                    <p className="extra-info-leftside">
                        {humidity}<br>
                        </br>
                        Humidity
                    </p>
                </div>
            </div>
            <div className="weather-extra-info">
            <div className="two-sided-section">
                    <p><i className={"wi wi-rain"}></i></p>
                    <p className="extra-info-leftside">
                        {pressure}<br>
                        </br>
                        Pressure
                    </p>
                </div>


            <div className="two-sided-section">
                    <p><i className={"wi wi-strong-wind"}></i></p>
                    <p className="extra-info-leftside">
                        {speed}<br>
                        </br>
                        Speed
                    </p>
                </div>
            </div>
        </div>
     </article> 
    </>
  )
}

export default Weathercard
